<template>
  <transition name="fade">
    <div v-show="show" class="container">
      <action
        action-class="yellow"
        text="回首頁"
        class="icon-tree"
        @goNext="$router.push('/')"
      >
        <template v-slot:icon>
          <font-awesome-icon :icon="['fas', 'caret-right']" size="lg" />
        </template>
      </action>
      <video id="myVideo" class="video-js vjs-theme-fantasy">
        <source src="@/assets/video2.mp4" type="video/mp4" />
      </video>
    </div>
  </transition>
</template>
<script>
import Action from "@/components/Action.vue";
import "@videojs/themes/dist/fantasy/index.css";
import "@videojs/themes/dist/city/index.css";
import "@videojs/themes/dist/forest/index.css";
import "@videojs/themes/dist/sea/index.css";

export default {
  components: { Action },
  data() {
    return {
      player: null,
      show: false
    };
  },
  mounted() {
    setTimeout(() => {
      this.show = true;
      this.initVideo();
    }, 300);
  },
  beforeDestroy() {
    if (this.player) {
      this.player.dispose();
    }
  },
  methods: {
    initVideo() {
      let width = 300 + 700 * ((window.innerWidth - 300) / (1600 - 300));
      let height = 200 + 250 * ((window.innerHeight - 200) / (900 - 300));
      this.player = this.$video(
        "myVideo",
        {
          controls: true,
          autoplay: "muted",
          preload: "auto",
          width: `${width}px`,
          height: `${height}px`
        },
        function onPlayerReady() {
          console.log("onPlayerReady", this);
        }
      );
      this.player.on("pause", () => {
        console.log("i am pause");
      });
      this.player.on("ended", () => {
        console.log("i am ended");
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.container {
  box-shadow: 0 19px 38px rgba(0, 0, 0, 0.3), 0 15px 12px rgba(0, 0, 0, 0.22);
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  border-radius: 25px;
  display: flex;
}
.icon-tree {
  position: absolute;
  bottom: -4em;
  right: -10px;
  // width: 80px;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>